import * as React from 'react';
import { inputFormatters } from 'ui-common';
import DataInput from '../DataInput';
import { getIdFromName } from 'login-components/Common/Inputs/inputUtils';

// TODO: Normalize this to be a limited-length number input if that's ever needed.
class ZipCodeInput extends React.Component<InputProps, {}> {
  private contextProps: DataInputContextProps;
  private inputProps: DirectInputProps;

  constructor(props) {
    super(props);
    this.contextProps = {
      label: props.label,
      format: inputFormatters.ZIPCODE.format,
      normalize: inputFormatters.ZIPCODE.normalize,
    };

    this.inputProps = {
      ...props.input,
      id: getIdFromName(props.input.name),
      name: props.input.name,
      type: 'number',
    };
  }

  render() {
    const { input, meta } = this.props;
    // Don't rewrite the whole inputProps object, just
    // pass through the new value.
    this.inputProps.value = input.value;
    this.contextProps.error = meta.touched && meta.error;

    return (
      <div className="ZipCodeInput">
        <DataInput contextProps={this.contextProps} inputProps={this.inputProps} />
      </div>
    );
  }
}

export const ZipCodeInputConfig = {
  component: ZipCodeInput,
  requiredLength: 5,
};

export default ZipCodeInput;
